import momentTimezone from 'moment-timezone';
import Cookies from 'universal-cookie';

const SUBSHIFT_HOURS = 2;
const SLOTS_PER_DAY = 24 / SUBSHIFT_HOURS;

const setEquals = (a, b) => a.size === b.size && [...a].every((value) => b.has(value));

const isAdjacentSlot = (prev, next) => {
  if (prev.location[0] === next.location[0]) {
    return next.location[1] - prev.location[1] === SUBSHIFT_HOURS;
  }
  if (next.location[0] - prev.location[0] === 1) {
    return prev.location[1] === (SLOTS_PER_DAY - 1) * SUBSHIFT_HOURS && next.location[1] === 0;
  }
  return false;
};

const postGenerateScheduleRequest = (data) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const dataAccounts = [];

  for (let i = 0; i < data?.accounts?.length; i++) {
    const account = data?.accounts[i];

    const allSchedules = [];
    for (let j = 0; j < account.datas?.length; j++) {
      const weeks = data?.accounts[i].datas[j];
      for (let k = 0; k < weeks?.schedules?.length; k++) {
        const schedule = weeks.schedules[k];
        const ref = new Date(schedule.subShiftStartTime);
        const year = ref.getFullYear();
        const month = ref.getMonth();
        const startMoment = momentTimezone.tz([year, month, schedule.location[0], schedule.location[1], 0, 0], timezone);
        const endMoment = startMoment.clone().add(SUBSHIFT_HOURS, 'hours');
        allSchedules.push({ schedule, startMs: startMoment.valueOf(), endMs: endMoment.valueOf() });
      }
    }

    const slotMap = new Map();
    for (const { schedule, startMs, endMs } of allSchedules) {
      const key = `${schedule.location[0]},${schedule.location[1]}`;
      if (!slotMap.has(key)) {
        slotMap.set(key, {
          location: schedule.location,
          hostSet: new Set(),
          startMs,
          endMs,
        });
      }
      slotMap.get(key).hostSet.add(schedule.userId);
    }

    const sortedSlots = [...slotMap.values()].sort((a, b) => {
      if (a.location[0] !== b.location[0]) return a.location[0] - b.location[0];
      return a.location[1] - b.location[1];
    });

    const groups = [];
    for (const slot of sortedSlots) {
      const last = groups[groups.length - 1];
      if (last && setEquals(last.hostSet, slot.hostSet) && isAdjacentSlot(last.lastSlot, slot)) {
        last.endMs = slot.endMs;
        last.lastSlot = slot;
      } else {
        groups.push({
          hostSet: new Set(slot.hostSet),
          startMs: slot.startMs,
          endMs: slot.endMs,
          lastSlot: slot,
        });
      }
    }

    const schedules = [];
    for (const group of groups) {
      const hostIds = [...group.hostSet].sort((a, b) => String(a).localeCompare(String(b)));
      for (const userId of hostIds) {
        schedules.push({
          userId,
          subShiftStartTime: momentTimezone.tz(new Date(group.startMs), timezone).format(),
          subShiftEndTime: momentTimezone.tz(new Date(group.endMs), timezone).format(),
          accountId: account?.accountId,
          studioId: account?.studioId,
        });
      }
    }

    const accountMapped = {
      name: account?.name,
      accountId: account?.accountId,
      studioId: account?.studioId,
      studioName: account?.studioName,
      schedules,
    };
    dataAccounts.push(accountMapped);
  }

  const payload = {
    generatedScheduleId: data?.metadata?.generatedScheduleId,
    yearMonth: data?.metadata?.yearMonth,
    data: dataAccounts,
  };

  return payload;
};

export default postGenerateScheduleRequest;
